export default {
  id: "page3",
  header: "Dane osobowe",
  questions: [
    {
      id: "respondent_lowFat",
      number: "13",
      label:
        "Czy zdarza się Panu(i) spożywać jakiekolwiek produkty o obniżonej zawartości tłuszczu?",
      type: "radio",

      required: true,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      id: "respondent_lowSugar",
      number: "14",
      label:
        "Czy zdarza się Panu(i) spożywać jakiekolwiek produkty o obniżonej zawartości cukru?",
      type: "radio",
      required: true,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      id: "respondent_bio",
      number: "15",
      label:
        "Czy zdarza się Panu(i) spożywać jakiekolwiek produkty typu BIO (ekologiczne)?",
      type: "radio",
      required: true,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      id: "respondent_protein",
      number: "16",
      label:
        "Czy zdarza się Panu(i) spożywać jakiekolwiek produkty proteinowe/wysokobiałkowe?",
      type: "radio",
      required: true,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      id: "respondent_glutenfree",
      number: "17",
      label:
        "Czy zdarza się Panu(i) spożywać jakiekolwiek produkty bezglutenowe?",
      type: "radio",
      required: true,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page3.js